import React from "react";
import {
  StyledContainer,
  StyledLink,
  StyledZiapngLink,
} from "./StyledComponents";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ButtonComp from "../../../common/elements/Button";
import { useHistory } from "react-router";
import auctions from "../../../services/ProductsApiService";

interface IProps {
  label?: string;
  children?: any;
  color?: string;
  pageLink?: string;
  LinkComponent?: any;
  isMobile?: boolean;
  alignItems?: string;
  justifyContent?: string;
  className?: string;
  container?: boolean;
  ref?: React.Ref<any>;
  id?: string;
  isZipang?: boolean;
}

const useStyles = makeStyles({
  maxWidthLg: {
    paddingRight: 0,
  },
  container: {
    marginBottom: "1em",
  },
  marginRight: {
    marginRight: "1em",
  },
  alignSelfFlexEnd: {
    alignSelf: "flex-end",
  },
  // New class to align the strong tag vertically when the outer grid is flex-start/center
  alignTextBaseline: {
    display: "flex",
    alignItems: "baseline",
  },
});

const ZipangSection = ({
  label,
  color,
  children,
  pageLink,
  isMobile,
  alignItems,
  justifyContent,
  container,
  LinkComponent,
  ref,
  id,
  isZipang,
  ...props
}: IProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const handleCheckCatalog = async (e: any) => {
    e.preventDefault();

    localStorage.setItem("isZipangDomain", "true");
    localStorage.setItem("isGlowstarDomain", "false");

    const auctionlist = await auctions();

    if (!auctionlist?.results || auctionlist.results.length === 0) {
      history.push("/home");
      return;
    }

    const {
      auctionType,
      id: auctionId,
      auctionUserId,
      name: auctionName,
      startDate: auctionDate,
    } = auctionlist.results[auctionlist.results.length - 1];

    console.log("Auctions data:", auctionlist);

    if (auctionType !== undefined && auctionType !== "Live") {
      history.push({
        pathname: `/preview/tendor/products/${auctionId}/${auctionUserId}/${auctionName}/${auctionDate}`,
      });
    } else {
      history.push({
        pathname: `/preview/products/${auctionId}/${encodeURIComponent(
          auctionName
        )}/${encodeURIComponent(auctionDate)}`,
      });
    }

    console.log("Clicked on Buy Diamonds", history.location.pathname);
  };

  return (
    <StyledContainer id={id} ref={ref} item xs={12} color={color} {...props}>
      <Container classes={isMobile ? classes : {}}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center" // Reverted to center for robust horizontal alignment
          direction="row"
          style={{
            flexWrap: isMobile ? "nowrap" : "wrap",
            marginBottom: "10px",
          }} // Prevents wrapping in mobile
        >
          {label && (
            <Grid
              item
              style={{
                textAlign: "left",
                minWidth: 0,
                paddingRight: isMobile ? "8px" : "0",
              }}
              className={isMobile ? classes.alignTextBaseline : ""}
            >
              <strong
                style={{
                  textTransform: "capitalize",
                  paddingLeft: isMobile ? 0 : "1%",
                  fontSize: isMobile ? "1.2em" : "1em",
                  fontWeight: "bolder",
                  whiteSpace: isMobile ? "normal" : "nowrap",
                }}
              >
                {label}
              </strong>
            </Grid>
          )}

          <Grid
            item
            container
            direction={isMobile ? "column" : "row"}
            alignItems="center"
            justifyContent="flex-end" // Aligns the content of this wrapper to the right
          >
            {pageLink && (
              <StyledZiapngLink
                className={`${classes.marginRight} ${
                  isMobile ? classes.alignSelfFlexEnd : ""
                }`}
                to={pageLink}
                style={{
                  textDecoration: "underline",
                  fontSize: isMobile ? "0.7em" : "0.9em",
                  marginBottom: isMobile ? "8px" : "0px",
                }}
              >
                <strong>{t("common:header:buttons:viewAllFeatured")}</strong>
              </StyledZiapngLink>
            )}

            <ButtonComp
              type="contained-red"
              className={isMobile ? classes.alignSelfFlexEnd : undefined}
              onClick={handleCheckCatalog}
            >
              {t("common:header:buttons:checkCatalogue")}
            </ButtonComp>
          </Grid>

          {LinkComponent && <LinkComponent />}
        </Grid>

        <Grid container>{children}</Grid>
      </Container>
    </StyledContainer>
  );
};

export default ZipangSection;
